import React from 'react';
import NoAccessAlertUpgradePlan from './NoAccessAlertUpgradePlan';
import NoAccessMessageResultNotAuthorized from './NoAccessMessageResultNotAuthorized';
import { Result, Button } from 'antd';

const PageExceptions = ({ statusCode, onUpgrade }) => {
  switch (statusCode) {
    // case 403:
    //   return <NoAccessAlertUpgradePlan onUpgrade={onUpgrade} />;
    case 403:
      return <NoAccessMessageResultNotAuthorized  />;
      
    case 404:
      return (
        <Result
          status="404"
          title="404"
          subTitle="Sorry, the page you visited does not exist."
        />
      );

    default:
      return (
        <Result
        status={statusCode}
        title={`Something went wrong`}
        subTitle={`${statusCode} code.Please try again later or contact support. to see more details check the console.`}
      />
      );
  }
};

export default PageExceptions;
